/* GOWin® Store — presentación de precios del carrito, 2026-08-07 */
(() => {
  if (window.GowinCartPriceV1) return;
  window.GowinCartPriceV1 = true;

  const DATA_SELECTOR = '[data-gowin-cart-price-data]';
  let scheduled = false;
  let observedDrawer = null;

  const visuallyHidden = (text) => {
    const span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = text;
    return span;
  };

  const signatureFor = (item) => [
    item.index,
    item.unitRegular,
    item.unitFinal,
    item.lineRegular,
    item.lineFinal,
    item.savingsPercent,
  ].join(':');

  const buildUnitPrice = (item) => {
    const root = document.createElement('div');
    root.className = 'gowin-cart-price';
    root.dataset.gowinPriceSignature = signatureFor(item);

    if (item.hasSavings) {
      const values = document.createElement('div');
      values.className = 'gowin-cart-price__values';

      values.append(visuallyHidden('Precio de oferta:'));
      const current = document.createElement('strong');
      current.className = 'gowin-cart-price__current';
      current.textContent = item.unitFinal;
      values.append(current);

      values.append(visuallyHidden('Precio regular:'));
      const regular = document.createElement('s');
      regular.className = 'gowin-cart-price__regular';
      regular.textContent = item.unitRegular;
      values.append(regular);

      const badge = document.createElement('span');
      badge.className = 'gowin-cart-price__badge';
      badge.textContent = `AHORRAS ${item.savingsPercent}%`;
      badge.setAttribute('aria-label', `Ahorras ${item.savingsPercent} por ciento`);

      root.append(values, badge);
      return root;
    }

    const current = document.createElement('span');
    current.className = 'gowin-cart-price__current gowin-cart-price__current--regular';
    current.textContent = item.unitFinal;
    root.append(current);
    return root;
  };

  const buildLinePrice = (item) => {
    const root = document.createElement('div');
    root.className = 'gowin-cart-line-price';
    root.dataset.gowinPriceSignature = signatureFor(item);

    if (item.hasSavings) {
      root.append(visuallyHidden('Total regular:'));
      const regular = document.createElement('s');
      regular.className = 'gowin-cart-line-price__regular';
      regular.textContent = item.lineRegular;
      root.append(regular);

      root.append(visuallyHidden('Total con descuento:'));
      const current = document.createElement('strong');
      current.className = 'gowin-cart-line-price__current';
      current.textContent = item.lineFinal;
      root.append(current);
      return root;
    }

    const current = document.createElement('strong');
    current.className = 'gowin-cart-line-price__current gowin-cart-line-price__current--regular';
    current.textContent = item.lineFinal;
    root.append(current);
    return root;
  };

  const replaceUnitPrice = (row, item) => {
    const title = row.querySelector('.cart-item__details .cart-item__name');
    const current = title?.nextElementSibling;
    if (!title || !current) return;

    const signature = signatureFor(item);
    if (current.matches('.gowin-cart-price') && current.dataset.gowinPriceSignature === signature) return;

    if (
      !current.matches(
        '.cart-item__discounted-prices, .product-option, .gowin-cart-price'
      )
    ) return;

    current.replaceWith(buildUnitPrice(item));
  };

  const replaceLinePrice = (row, item) => {
    const wrapper = row.querySelector('.cart-item__totals .cart-item__price-wrapper');
    if (!wrapper) return;

    const current = [...wrapper.children].find((element) =>
      element.matches('.cart-item__discounted-prices, .price.price--end, .gowin-cart-line-price')
    );
    if (!current) return;

    const signature = signatureFor(item);
    if (current.matches('.gowin-cart-line-price') && current.dataset.gowinPriceSignature === signature) return;

    current.replaceWith(buildLinePrice(item));
  };

  const readData = (drawer) => {
    const dataElement = drawer.querySelector(DATA_SELECTOR);
    if (!dataElement) return [];

    try {
      const parsed = JSON.parse(dataElement.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('GOWin: no se pudo leer la información de precios del carrito.', error);
      return [];
    }
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const data = readData(drawer);
    if (!data.length) return;

    const rows = Array.from(drawer.querySelectorAll('.cart-items .cart-item'));

    data.forEach((item, position) => {
      const row = rows[position] || drawer.querySelector(`#CartDrawer-Item-${item.index}`);
      if (!row) return;
      replaceUnitPrice(row, item);
      replaceLinePrice(row, item);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const observer = new MutationObserver(schedule);

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      observer.disconnect();
      observer.observe(drawer, { childList: true, subtree: true });
      observedDrawer = drawer;
    }

    schedule();
  };

  const enhanceAfterPatch = () => {
    // Este listener se registra antes que el de cantidad (v3), por el orden de carga.
    // Así el precio existe cuando v3 reconstruye el selector de cantidad inline.
    enhance();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhanceAfterPatch);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
